/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

export * from '@thesisedu/feature-widgets-core/dist/editorNodes/TableNode'
import * as Table from '@thesisedu/feature-widgets-core/dist/editorNodes/TableNode'
import { EditorConfig, LexicalEditor } from 'lexical'
import * as React from 'react'

import TableComponent from './TableComponent'

Table.TableNode.prototype.decorate = function (
  this: Table.TableNode,
  _: LexicalEditor,
  config: EditorConfig,
) {
  return <TableComponent nodeKey={this.__key} theme={config.theme} rows={this.__rows} />
}
